module.exports = __webpack_public_path__ + "img/t2-social-links.ac401cf8.png";